import ProfileTab from './profile-tab';
import { UserInfo } from '../../../api/user/user-api-state';
import { BriefcaseIcon, UserIcon } from '../../../assets/icon/svg';

interface Props {
    userData: UserInfo | undefined;
}

export default function ProfileView({ userData }: Props) {

    if (!userData) return null;

    return (
        <div className="space-y-4">
            {/* PERSONAL INFORMATION */}
            <section className="rounded-xl border border-gray-200 bg-white">
                <div className="flex items-center gap-2 border-b border-gray-100 px-4 py-3">
                    <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-[#186cb2]/10 text-[#186cb2]">
                        <UserIcon width={15} height={15} />
                    </div>
                    <div>
                        <p className="text-xs font-semibold text-gray-800">
                            Personal Information
                        </p>
                        <p className="text-[10px] text-gray-400">
                            Basic information associated with your account
                        </p>
                    </div>
                </div>
                <div className="grid grid-cols-1 gap-2 p-3 sm:grid-cols-2 lg:grid-cols-3">
                    <ProfileTab
                        labelName="First Name"
                        labelData={userData.firstname}
                    />
                    <ProfileTab
                        labelName="Middle Name"
                        labelData={userData.middlename || '-'}
                    />
                    <ProfileTab
                        labelName="Last Name"
                        labelData={userData.lastname}
                    />
                    <ProfileTab
                        labelName="Suffix"
                        labelData={userData.suffix || '-'}
                    />
                    <ProfileTab
                        labelName="Phone Number"
                        labelData={userData.phoneNumber || '-'}
                    />
                    <ProfileTab
                        labelName="Email Address"
                        labelData={userData.email || '-'}
                    />
                </div>
            </section>

            {/* WORK INFORMATION */}
            <section className="rounded-xl border border-gray-200 bg-white">
                <div className="flex items-center gap-2 border-b border-gray-100 px-4 py-3">
                    <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-[#186cb2]/10 text-[#186cb2]">
                        <BriefcaseIcon width={15} height={15} />
                    </div>
                    <div>
                        <p className="text-xs font-semibold text-gray-800">
                            Work Information
                        </p>
                        <p className="text-[10px] text-gray-400">
                            Your organizational and account details
                        </p>
                    </div>
                </div>
                <div className="grid grid-cols-1 gap-2 p-3 sm:grid-cols-2 lg:grid-cols-3">
                    {userData.position && (
                        <ProfileTab
                            labelName="Position"
                            labelData={userData.position}
                        />
                    )}
                    <ProfileTab
                        labelName="Role"
                        labelData={userData.role?.name || '-'}
                    />
                    <ProfileTab
                        labelName="Department"
                        labelData={userData.department?.name || '-'}
                    />
                    <ProfileTab
                        labelName="Location"
                        labelData={userData.location?.name || '-'}
                    />
                    <ProfileTab
                        labelName="Agent Code"
                        labelData={userData.agent_code || '-'}
                    />
                </div>
            </section>
        </div>
    );
}